import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { getViewYmd } from '../../../../../helpers/common';
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import { viewPrice } from '../../../../../helpers/solution';
import RowAction from './RowParts/RowAction';
class SolutionRow extends Component {
    constructor(props) {
        super(props);
        this.onClickOpen = () => {
            const { isOpen } = this.state;
            this.setState({ isOpen: !isOpen });
        };
        this.state = {
            isOpen: false,
        };
    }
    render() {
        const { onClickOrder, onClickReview, onClickSendOff, row } = this.props;
        const { isOpen } = this.state;
        const { created_at: createdAt, solution } = row;
        const { period, price, professional_organization: professionalOrganization, title, } = solution;
        return (_jsxs("tr", Object.assign({ className: `solution_row ${isOpen ? 'is_open' : ''}` }, { children: [_jsxs("td", Object.assign({ className: 'solution_col solution_name_col table_head_col' }, { children: [_jsxs("div", Object.assign({ className: 'solution_name_box' }, { children: [_jsx(Link, Object.assign({ className: 'link', to: `/solutions/${solution.id}` }, { children: title })), _jsx("small", Object.assign({ className: 'small' }, { children: professionalOrganization.name }))] })), _jsx("button", Object.assign({ className: 'material-icons toggle', onClick: this.onClickOpen, type: 'button' }, { children: isOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }))] })), _jsx("td", Object.assign({ className: 'solution_col solution_price_col table_body_col', "data-label": '金額／期間' }, { children: _jsxs("span", Object.assign({ className: 'text' }, { children: [`${viewPrice(price)}万円程度`, _jsx("br", {}), `約${period}週間`] })) })), _jsx("td", Object.assign({ className: 'solution_col solution_created_col table_body_col', "data-label": 'お問い合わせ日' }, { children: getViewYmd(createdAt) })), _jsx("td", Object.assign({ className: 'solution_col solution_action_col table_body_col', "data-label": '選定結果' }, { children: _jsx(RowAction, { item: row, onClickOrder: onClickOrder, onClickReview: onClickReview, onClickSendOff: onClickSendOff }) }))] })));
    }
}
SolutionRow.propTypes = {
    onClickOrder: propFunc().isRequired,
    onClickReview: propFunc().isRequired,
    onClickSendOff: propFunc().isRequired,
    row: propShape().isRequired,
};
export default SolutionRow;
